import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BehaviorSubject, of, switchMap, tap } from 'rxjs';
import { FeatureFlag } from 'src/app/shared/models/enums/feature-flag';
import { CustomFieldsService } from '../custom-fields.service';
import { CustomFieldEntity } from 'src/app/shared/models/custom-field-entity';
import { IfLDFeatureDirective } from 'src/app/shared/directives/if-ld-feature.directive';
import { MatLegacyCardModule } from '@angular/material/legacy-card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CustomFieldGridViewerTableComponent } from 'src/app/shared/components/custom-fields/custom-field-viewer/custom-field-grid-viewer-table/custom-field-grid-viewer-table.component';

@Component({
    selector: 'nova-custom-field-viewer',
    templateUrl: './custom-field-viewer.component.html',
    styleUrls: ['./custom-field-viewer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        IfLDFeatureDirective,
        CommonModule,
        CustomFieldGridViewerTableComponent,
        MatLegacyCardModule,
        MatProgressSpinnerModule
    ]
})
export class CustomFieldViewerComponent {
    @Input() wrapWithCard = true;
    isLoading = true;
    displayedColumns: string[] = ['name', 'value'];
    featureFlag = FeatureFlag;
    service = inject(CustomFieldsService);
    subject$ = new BehaviorSubject<CustomFieldEntity>(null);
    values$ = this.subject$.pipe(
        switchMap((entity) => {
            return entity ? this.service.getValues(entity).pipe(tap(() => (this.isLoading = false))) : of([]);
        })
    );

    constructor() {}

    @Input()
    set entity(entity: CustomFieldEntity) {
        this.subject$.next(entity);
    }
}
